import { render, staticRenderFns } from "./GhostIdentityButton.vue?vue&type=template&id=78ad778f&scoped=true&"
import script from "./GhostIdentityButton.vue?vue&type=script&lang=js&"
export * from "./GhostIdentityButton.vue?vue&type=script&lang=js&"
import style0 from "./GhostIdentityButton.vue?vue&type=style&index=0&id=78ad778f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ad778f",
  null
  
)

export default component.exports